export default __webpack_public_path__ + "static/media/medical-imaging.096ac386.jpg";